// components/Navbar.jsx
//
// Shows different links depending on whether user is logged in, and
// whether they are an admin. Reads from localStorage (set during
// Login/Signup) to know current state.
//
// RESPONSIVE BEHAVIOR:
// - Desktop (>768px): links show inline in the navbar, exactly as before.
// - Mobile/tablet (<=768px): links are hidden via CSS (.navbar-links-desktop
//   is display:none under the breakpoint in theme.css) and a hamburger
//   button appears instead. Tapping it expands a dropdown panel with the
//   same links, stacked vertically. Selecting any link closes the menu.

import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

function Navbar() {
  const navigate = useNavigate();
  const userJSON = localStorage.getItem('user');
  const user = userJSON ? JSON.parse(userJSON) : null;
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setMenuOpen(false);
    navigate('/login');
  };

  const closeMenu = () => setMenuOpen(false);

  // The link list is built once and reused in both the desktop inline
  // nav and the mobile dropdown, so they never fall out of sync.
  const links = user ? (
    <>
      <span className="muted navbar-greeting" style={{ fontSize: '14px' }}>Hi, {user.name}</span>
      <Link to="/my-orders" onClick={closeMenu}>My Orders</Link>
      {user.isAdmin && (
        <>
          <Link to="/admin" onClick={closeMenu}>Admin Panel</Link>
          <Link to="/admin/orders" onClick={closeMenu}>Manage Orders</Link>
        </>
      )}
      <button onClick={handleLogout} className="btn-outline navbar-logout-btn" style={{ padding: '6px 14px', fontSize: '13px' }}>
        Logout
      </button>
    </>
  ) : (
    <>
      <Link to="/login" onClick={closeMenu}>Login</Link>
      <Link to="/signup" onClick={closeMenu}>Sign Up</Link>
    </>
  );

  return (
    <nav className="navbar">
      <Link to="/" className="logo" style={{ textDecoration: 'none', color: 'var(--text)' }} onClick={closeMenu}>
        NFX<span>SELLER</span>
      </Link>

      {/* Desktop nav links - hidden on mobile via CSS */}
      <div className="navbar-links-desktop" style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
        {links}
      </div>

      {/* Hamburger button - only visible on mobile via CSS */}
      <button
        className="navbar-hamburger"
        onClick={() => setMenuOpen((open) => !open)}
        aria-label={menuOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={menuOpen}
      >
        <span className={`hamburger-bar ${menuOpen ? 'bar-1-open' : ''}`}></span>
        <span className={`hamburger-bar ${menuOpen ? 'bar-2-open' : ''}`}></span>
        <span className={`hamburger-bar ${menuOpen ? 'bar-3-open' : ''}`}></span>
      </button>

      {/* Mobile dropdown menu - only rendered/visible on mobile via CSS,
          expands/collapses smoothly using the .open class (max-height
          transition defined in theme.css) */}
      <div className={`navbar-mobile-menu ${menuOpen ? 'open' : ''}`}>
        {links}
      </div>
    </nav>
  );
}

export default Navbar;
